import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router-dom';
// auth
import { AuthGuard } from 'src/auth/guard';
// layouts
import MardamLayout from 'src/layouts/mardam';
// components
import { LoadingScreen } from 'src/components/loading-screen';
import TenantCreatePage from 'src/pages/mardam-dashboard/tenants/new';

// ----------------------------------------------------------------------

// OVERVIEW
const IndexPage = lazy(() => import('src/pages/mardam-dashboard/app'));
const TenantsListPage = lazy(() => import('src/pages/mardam-dashboard/tenants/list'));
const SubscriptionListView = lazy(() => import('src/pages/mardam-dashboard/subscriptions/list'));

// TEST RENDER PAGE BY ROLE
const PermissionDeniedPage = lazy(() => import('src/pages/dashboard/permission'));
// BLANK PAGE
const BlankPage = lazy(() => import('src/pages/dashboard/blank'));

// ----------------------------------------------------------------------

export const mardamRoutes = [
  {
    path: 'mardam',
    element: (
      <AuthGuard>
        <MardamLayout>
          <Suspense fallback={<LoadingScreen />}>
            <Outlet />
          </Suspense>
        </MardamLayout>
      </AuthGuard>
    ),
    children: [
      { element: <IndexPage />, index: true },
      { path: 'tenants', element: <TenantsListPage /> },
      { path: 'subscriptions', element: <SubscriptionListView /> },
      { path: 'tenants/new', element: <TenantCreatePage /> },
      { path: 'settings', element: <IndexPage /> },
      { path: 'permission', element: <PermissionDeniedPage /> },
      { path: 'blank', element: <BlankPage /> },
    ],
  },
];
